import { useState } from 'react';

import { TFormalOffer } from '@helpers/FormalOffers/formalOffers.types';
import { Button, Modal } from '@iwoca/orion';
import { Text } from '@iwoca/orion-ui';
import { FormattedMessage } from 'react-intl';

import EarlyRepaymentCalculator from '../../../../../myOffers/approvedView/earlyRepaymentCalculator/EarlyRepayment';
import { getMaxDate } from '../../../../../myOffers/approvedView/earlyRepaymentCalculator/EarlyRepaymentHelper';
import { getLoanDurationInMonths } from '../../../../../myOffers/MyOffers.helpers';

export const CalculatePotentialSavings = ({
    selectedOffer,
    drawdownAmount
}: {
    selectedOffer: TFormalOffer;
    drawdownAmount: number;
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const loanDuration = getLoanDurationInMonths(selectedOffer.duration!);
    const maxDate = getMaxDate(selectedOffer.duration!.amount);

    return (
        <>
            <Modal
                size="large"
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                closeIcon
            >
                <EarlyRepaymentCalculator
                    drawdownAmount={drawdownAmount}
                    offerId={selectedOffer.offer_id!}
                    loanDuration={loanDuration}
                    productType={selectedOffer.product_type!}
                    maxDate={maxDate}
                />
            </Modal>

            <div className="flex w-full gap-s rounded-s bg-primary-97 p-m">
                <CalculatorIcon />
                <div>
                    <Text className="text-s">
                        <FormattedMessage
                            id="_.topup_choice.no_early_repayment_fees"
                            defaultMessage="Remember, no early repayment fees"
                        />
                    </Text>
                    <Button
                        variant="tertiary"
                        className="h-[30px] px-0"
                        size="small"
                        onClick={() => setIsModalOpen(true)}
                    >
                        <FormattedMessage
                            id="_.topup_choice.calculate_potential_savings"
                            defaultMessage="Calculate your potential savings"
                        />
                    </Button>
                </div>
            </div>
        </>
    );
};

const CalculatorIcon = () => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="size-[18px] shrink-0"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 1.99984C3.63181 1.99984 3.33333 2.29831 3.33333 2.6665V13.3332C3.33333 13.7014 3.63181 13.9998 4 13.9998H12C12.3682 13.9998 12.6667 13.7014 12.6667 13.3332V2.6665C12.6667 2.29831 12.3682 1.99984 12 1.99984H4ZM2 2.6665C2 1.56193 2.89543 0.666504 4 0.666504H12C13.1046 0.666504 14 1.56193 14 2.6665V13.3332C14 14.4377 13.1046 15.3332 12 15.3332H4C2.89543 15.3332 2 14.4377 2 13.3332V2.6665ZM4.66667 3.99984C4.66667 3.63165 4.96514 3.33317 5.33333 3.33317H10.6667C11.0349 3.33317 11.3333 3.63165 11.3333 3.99984C11.3333 4.36803 11.0349 4.6665 10.6667 4.6665H5.33333C4.96514 4.6665 4.66667 4.36803 4.66667 3.99984ZM4.66667 6.6665C4.66667 6.29831 4.96514 5.99984 5.33333 5.99984H5.34C5.70819 5.99984 6.00667 6.29831 6.00667 6.6665C6.00667 7.03469 5.70819 7.33317 5.34 7.33317H5.33333C4.96514 7.33317 4.66667 7.03469 4.66667 6.6665ZM7.33333 6.6665C7.33333 6.29831 7.63181 5.99984 8 5.99984H8.00667C8.37486 5.99984 8.67333 6.29831 8.67333 6.6665C8.67333 7.03469 8.37486 7.33317 8.00667 7.33317H8C7.63181 7.33317 7.33333 7.03469 7.33333 6.6665ZM10 6.6665C10 6.29831 10.2985 5.99984 10.6667 5.99984H10.6733C11.0415 5.99984 11.34 6.29831 11.34 6.6665C11.34 7.03469 11.0415 7.33317 10.6733 7.33317H10.6667C10.2985 7.33317 10 7.03469 10 6.6665ZM4.66667 9.33317C4.66667 8.96498 4.96514 8.6665 5.33333 8.6665H5.34C5.70819 8.6665 6.00667 8.96498 6.00667 9.33317C6.00667 9.70136 5.70819 9.99984 5.34 9.99984H5.33333C4.96514 9.99984 4.66667 9.70136 4.66667 9.33317ZM7.33333 9.33317C7.33333 8.96498 7.63181 8.6665 8 8.6665H8.00667C8.37486 8.6665 8.67333 8.96498 8.67333 9.33317C8.67333 9.70136 8.37486 9.99984 8.00667 9.99984H8C7.63181 9.99984 7.33333 9.70136 7.33333 9.33317ZM10.6667 8.6665C11.0349 8.6665 11.3333 8.96498 11.3333 9.33317V11.9998C11.3333 12.368 11.0349 12.6665 10.6667 12.6665C10.2985 12.6665 10 12.368 10 11.9998V9.33317C10 8.96498 10.2985 8.6665 10.6667 8.6665ZM4.66667 11.9998C4.66667 11.6316 4.96514 11.3332 5.33333 11.3332H5.34C5.70819 11.3332 6.00667 11.6316 6.00667 11.9998C6.00667 12.368 5.70819 12.6665 5.34 12.6665H5.33333C4.96514 12.6665 4.66667 12.368 4.66667 11.9998ZM7.33333 11.9998C7.33333 11.6316 7.63181 11.3332 8 11.3332H8.00667C8.37486 11.3332 8.67333 11.6316 8.67333 11.9998C8.67333 12.368 8.37486 12.6665 8.00667 12.6665H8C7.63181 12.6665 7.33333 12.368 7.33333 11.9998Z"
                fill="#08172B"
            />
        </svg>
    );
};
